var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-md-3"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-10 offset-md-1",staticStyle:{"animation-delay":"50ms"}},[_c('IntroMySelf',{staticClass:"mt-md-5 mt-2"})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }